/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import Ideas from '/public/static/5-Ideas.png';
import Image from 'next/image';
export const meta = {
  author: 'Jens Arre Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  mdx: true,
  meta: meta,
  title: "36 Norske læringsteknologiselskap som endrer hvordan vi lærer",
  subTitle: "Norsk læringsteknologi (edtech) skyter fart. Her finner du 36 norske edtech-selskap som brenner for læring.",
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      h2: "h2",
      ol: "ol",
      li: "li",
      a: "a",
      hr: "hr",
      h1: "h1",
      strong: "strong"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.p, {
        children: "Norsk læringsteknologi (edtech) skyter fart. Her finner du 36 norske edtech-selskap som brenner for læring"
      }), "\n", _jsx(_components.h2, {
        children: "Hurtiglinker til selskapene"
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#basic-eSolutions",
            children: "Basic eSolutions"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#capeesh",
            children: "Capeesh"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#clarify",
            children: "Clarify"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#conexus",
            children: "Conexus"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#creaza",
            children: "Creaza"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#datatrotters",
            children: "Datatrotters"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#datatrotters",
            children: "Datatrotters"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#enkel-eksamen",
            children: "Enkel Eksamen"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#educas",
            children: "Educas"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#eduplaytion",
            children: "Eduplaytion"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#edyou",
            children: "EdYou"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#gcas",
            children: "GCas"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#hold",
            children: "Hold"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#hubro-education",
            children: "Hubro Education"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#Inkrement",
            children: "Inkrement"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#inspera",
            children: "Inspera"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#interactive-norway",
            children: "Interactive Norway"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#kahoot",
            children: "Kahoot"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#kikora",
            children: "Kikora"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#ks-ung",
            children: "KS Ung"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#leap-learning",
            children: "Leap Learning"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#learnlab",
            children: "Learnlab"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#leap-learning",
            children: "Leap Learning"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#learn-link",
            children: "LearnLink"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#lingu",
            children: "Lingu"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#ludenso",
            children: "Ludenso"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#made-to-grow",
            children: "Made To Grow"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#muscle-animations",
            children: "Muscle Animations"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#neurominders",
            children: "Neurominders"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#no-isolation",
            children: "No Isolation"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#scrimba",
            children: "Scrimba"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#curipod",
            children: "Curipod"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#skolon",
            children: "Skolon"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#skooler",
            children: "Skooler"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#trikks",
            children: "Trikks"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#undervisningsplan",
            children: "Undervisningsplan.no"
          })
        }), "\n"]
      }), "\n", _jsx("a", {
        name: "basic-eSolutions"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Basic eSolutions"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Ungdomsskole og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Basic eSolutions’ app Basic Matte eX har som mål å være den komplette appen for matte på ungdomsskolen og VGS. Appen lar elever lære seg matte hvor og når de vil, og bidrar på den måten til et motiverende læringsmiljø spesielt rettet mot elever som har vansker med å forstå matematikk."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://basic-matte.no/"
      }), "\n", _jsx("a", {
        name: "capeesh"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Capeesh"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole, videregående skole og voksenopplæring"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Capeesh tilbyr målrettet spillbasert norskopplæring til minoritetsspråklige i norsk skole og yrkesfag. Selskapet bygger en bro mellom elevens morsmål og undervisningsspråket, slik at undervisningshverdagen skal bli bedre for både lærere og elever."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.capeesh.com/no/"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Clarify"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole, videregående skole og høyere utdanning"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Clarify tilbyr digitale ordbøker med løsninger tilpasset ulike skoletrinn samt til profesjonell bruk. Selskapet gir deg muligheten til å slå opp i mer enn 700 ordbøker med mer enn 11 millioner artikler på 30 ulike språk."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.clarify.no/"
      }), "\n", _jsx("a", {
        name: "conexus"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Conexus"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Barnehage, grunnskole og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Conexus er i dag ledende innenfor læringsanalyse, og tilbyr hjelp til lærere, skoleledere og elever med helhetlig datadrevet oppfølging og kvalitetsutvikling, og derav bygge en bedre læringsplattform."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://conexus.net/"
      }), "\n", _jsx("a", {
        name: "creaza"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Creaza"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Creaza utvikler kreative og digitale læremidler som har som mål å engasjere og motivere elever. Deres løsninger utfordrer elever og lærere til å skape tegneserier, podcasts, hørespill, filmer og presentasjoner for å øke forståelse, refleksjon og diskusjon tilknyttet faglige problemstillinger."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://web.creaza.com/no/"
      }), "\n", _jsx("a", {
        name: "datatrotters"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Datatrotters"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Høyere utdanning, bedrifter og organisasjoner med kunnskapsformidlingsansvar"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Datatrotters utvikler spill for personer som ønsker å lære seg å utnytte den stadig økende mengden store data. Selskapet designer data-drevne læringsspill og opplevelser, med et mål om å forbedre brukernes datakompetanse. Spillene skal trene brukernes ferdigheter i å lese, analysere, tolke og kommunisere data."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.datatrotters.com/"
      }), "\n", _jsx("a", {
        name: "enkel-eksamen"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Enkel Eksamen"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Studenter i høyere utdanning"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Edrupt har utviklet enkel og effektiv videoundervisning på nett gjennom siden enkeleksamen.no. Siden tilbyr flere hundre timers undervisningsmateriale, i tillegg til 2 160 quiz-oppgaver fordelt på 37 kurs. Selskapet satser på eksamensrelevant undervisning, og har som mål å gjøre utdanning mer tilgjengelig og bedre tilpasset studenter."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.enkeleksamen.no/"
      }), "\n", _jsx("a", {
        name: "educas"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Educas"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Videregående skole og høyere utdanning"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Educas har utviklet produkt som tar sikte på å gi elever og studenter de verktøyene de trenger i en utfordrende studiehverdag. Produktet deres, Superlæring, er et digitalt video- og oppgavebasert kurs i studieteknikk, og har som mål å gjøre brukerne til eksperter i å “lære seg å lære”."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: http://www.educas.no/"
      }), "\n", _jsx("a", {
        name: "eduplaytion"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Eduplaytion"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Barneskole (Barn mellom 8-12 år)"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Eduplaytion har utviklet mattespillet Numetry, som skal gjøre mattelæring morsomt og engasjerende. Selskapets mål er å få barn over hele verden til å elske matte."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://numetrygame.com/"
      }), "\n", _jsx("a", {
        name: "edyou"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "EdYou"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Tilbydere av komplekse kurs/fag, for eksempel videregående skoler, universiteter eller store bedrifter."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " EdYou hjelper studentene å forstå hvorfor noe er vanskelig, og hva de bør trene på for best mulig læring. EdYou sin plattform finner fellestrekk mellom studentene, og identifiserer viktige sammenhenger i pensum, som videre brukes til å effektivisere læringsprosessen for alle på plattformen."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.edyou.no/"
      }), "\n", _jsx("a", {
        name: "gcas"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Gcas"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Ungdomsskole og VGS"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " GCAS inneholder alt pensumet knyttet til Geogebra som den norske skole bruker i sin undervisning. Dette betyr at programmet er like godt egnet for ungdomsskoleelever som for elever i den videregående skole."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://gcas.no/"
      }), "\n", _jsx("a", {
        name: "hold"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Hold"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Studenter i høyere utdanning"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Hold fjerner distraksjonene som følger med å være på nett 24/7. I Hold får du poeng ved å ikke være på mobilen, som kan veksles inn i diverse premier slik som en kopp kaffe."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.hold.app/student"
      }), "\n", _jsx("a", {
        name: "hubro-education"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Hubro Education"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Høyere utdanning"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Simuleringer er den ultimate måten å knytte teori og praksis sammen. Øk læringsutbyttet og engasjementet med å styre virtuelle bedrifter i Hubros simuleringsspill."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://hubro.education/no/"
      }), "\n", _jsx("a", {
        name: "Inkrement"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Inkrement"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole og VGS."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Inkrement utvikler programvare for kartlegging, læring og sertifisering. Selskapet har utviklet læringsplattformen Campus Inkrement som brukes av mer enn 2000 lærere i Norge. Plattformen kan benyttes til å følge opp lekser, og utarbeide egne kurs."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.inkrement.no/"
      }), "\n", _jsx("a", {
        name: "inspera"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Inspera"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole, VGS og høyere utdanning."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Inspera tilbyr en skyløsning for digitale vurderinger, prøver og eksamener. Systemene til selskapet støtter hele vurderingsprosessen, og gir deg muligheten til å planlegge, designe, utføre og rette vurderingen."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.inspera.com/"
      }), "\n", _jsx("a", {
        name: "interactive-norway"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Interactive Norway"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Interactive Norway er et kompetansesenter for interaktive skjermløsninger. Selskapet tilbyr smartboards til norske skoler, og har siden 2005 levert løsninger til mer enn halvparten av norske klasserom."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.interactive.no/"
      }), "\n", _jsx("a", {
        name: "kahoot"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Kahoot!"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Ethvert alderstrinn (Barnehage, grunnskole, videregående skole, høyere utdanning, bedrifter og privat)"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Kahoot! er en spillbasert læringsplattform som ønsker å styrke kunnskapsnivået i alle alderstrinn. Deres løsninger tilbys til barn, studenter og bedrifter, og gjør det enkelt for ethvert individ å lage, dele og spille kunnskapsspill. Kahoot! kan spilles overalt, sammen eller digitalt, ved bruk av en enhet som er tilkoblet internett. Kahoot! brukes i dag av mer enn 7 millioner lærere, flere hundre millioner studenter og familier, samt av 97% av Fortune 500 selskaper."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://kahoot.com/"
      }), "\n", _jsx("a", {
        name: "kikora"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Kikora"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Kikora tilbyr digitale løsninger for matematisk teori som dekker læreplanmålene for grunnskole og vgs. Selskapet tilbyr interaktive visualiseringer, spill og andre verktøy som skal bedre mattekunnskapen til de som benytter seg av Kikoras løsninger."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://kikora.no/"
      }), "\n", _jsx("a", {
        name: "ks-ung"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "KS Ung"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Ungdomsskole og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " KS Ung tilbyr en rekke digitale spill, læringsressurser og filmer om lokaldemokrati, kommuner og yrker i kommunal sektor. Ved å benytte seg av disse ressursene er målet at elever skal bli tryggere i å forstå hvordan en kommune er bygd opp, og hvordan ulike saker på kommunenivå bør løses."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.ks.no/ks-ung/"
      }), "\n", _jsx("a", {
        name: "leap-learning"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Leap Learning"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Leap Learning har utviklet mer enn 500 apper for lese- og skriveopplæring, matematikk, logikk og entreprenørskap. Disse appene skal gjøre elever i stand til å “lære å lære”. Selskapets tilbud benyttes av mer enn 200 skoler i Norge."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://leaplearning.no/"
      }), "\n", _jsx("a", {
        name: "learnlab"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "LearnLab"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " LearnLab har som mål å gi elever over hele verden lik tilgang til utdanning. Selskapet tilbyr gratis, innovative digitale løsninger for utdanning, og lar elever lære ved bruk av interaktive verktøy og oppgaver."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://learnlab.net/no/"
      }), "\n", _jsx("a", {
        name: "learn-link"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "LearnLink"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " LearnLink tilbyr online én-til-én-undervisning, som tar sikte på å bringe læringsgleden tilbake til brukerne. Selskapet baserer seg på tre begreper - mestringstro, mestring og motivasjon - som forutsetning for en positiv læringsprosess."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.learnlink.no/"
      }), "\n", _jsx("a", {
        name: "lingu"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Lingu"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Alle aldersklasser"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Lingu er en akkreditert språkskole som tilbyr språkkurs på diverse språk. Selskapet tilbyr både undervisning over nett og i klasserom."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://lingu.no/"
      }), "\n", _jsx("a", {
        name: "ludenso"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Ludenso"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Ludenso har utviklet et 3D-modelleringsverktøy som lar elever bygge sine egne modeller og figurer. Selskapet gir også brukerne muligheten til å oppleve det de har laget i AR. Verktøyene deres er utviklet for å utvide tilgangen skoler har på kreative og digitale løsninger."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.ludenso.no/"
      }), "\n", _jsx("a", {
        name: "made-to-grow"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "MadeToGrow"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Ungdomsskole, videregående skole og høyere utdanning"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " MadeToGrow utvikler digitale programmer for læring og utvikling, og ønsker å øke elevers motivasjon og mening, samt gjøre dem i stand til å takle utfordringer og endringer. Selskapet ønsker å rette større fokus på helse og selvfølelse blant elever, og på den måten bidra til at brukerne utvikler sitt potensial."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://madetogrow.no/"
      }), "\n", _jsx("a", {
        name: "muscle-animations"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "MuscleAnimations"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Høyere utdanning"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " MuscleAnimations har utviklet undervisningsmateriell for styrketreningsentusiaster. Selskapets løsninger benytter 3D-animasjoner for detaljerte styrke-teknikker, og for å gjøre biomekanikk forståelig for studenter."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.muscleanimations.com/"
      }), "\n", _jsx("a", {
        name: "neurominders"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Neurominders"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Barneskole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Neurominders utvikler spillet Dragon Minders. Dragon Minders er et morsomt spill som trener leseforståelse og styrker egen evne til å lære."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.neurominders.com/"
      }), "\n", _jsx("a", {
        name: "no-isolation"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "No Isolation"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " No Isolation ønsker å redusere ufrivillig ensomhet og sosial isolasjon ved å utvikle kommunikasjons-verktøy som hjelper syke barn å ha en tilnærmet normal skolehverdag. Selskapet har blant annet utviklet en robot som fungerer som et barns øyne, øre og stemme i klasserommet."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.noisolation.com/global/"
      }), "\n", _jsx("a", {
        name: "scrimba"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Scrimba"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Høyere utdanning"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Scrimba tilbyr kursmateriale innen koding for studenter. Selskapets mål er å utvikle den beste kode-skolen til lavest mulig kostnad for forbrukerne. For å gjøre dette mulig har selskapet utviklet et nytt video format for læring, kalt “scrims”."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://scrimba.com/"
      }), "\n", _jsx("a", {
        name: "Curipod"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Curipod"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Høyere utdanning og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Curipod hjelper forelesere å skape et digitalt læringsfellesskap, hvor studentene blir engasjert til å stille spørsmål og hjelpe hverandre. Å hjelpe hverandre skal være gøy!"]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://curipod.com"
      }), "\n", _jsx("a", {
        name: "skolon"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Skolon"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Skolon har utviklet en samlingsplass for alle digitale læringsressurser og læremidler. Selskapet tilbyr et bibliotek med digitale verktøy, læremidler, tjenester og apper for skolen, som kan integreres med populære læringsplattformer, G-suite og Office 365."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://skolon.com/no/"
      }), "\n", _jsx("a", {
        name: "skooler"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Skooler"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Skooler har utviklet et fleksibelt læringsverktøy som kan integreres med Teams og Microsoft 365. Verktøyet til Skooler skal effektivisere og strukturere jungelen av læringsplattformer, apper og enheter skoler arbeider i."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://skooler.com/"
      }), "\n", _jsx("a", {
        name: "trikks"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Trikks"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Høyere utdanning"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Trikks lar deg utvikle eget læringsinnhold ved bruk av videoer, spillbasert læring, nano læring og mer. Selskapets løsninger tillater selskaper og studenter å utvikle innhold som er tilpasset den enkelte."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.trikks.com/mainui/"
      }), "\n", _jsx("a", {
        name: "undervisningsplan"
      }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h1, {
        children: "Undervisningsplan.no"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "For hvem?:"
        }), " Grunnskole og videregående skole"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Hva gjør de?:"
        }), " Undervisningsplan.no ønsker å optimalisere læringsinnholdet i skolen, ved å gjøre tilgangen til ressurser og undervisningsopplegg så enkelt som mulig. Selskapet har utviklet en nettside som strukturerer alt av undervisningsopplegg, og tilpasser det til læreplanen."]
      }), "\n", _jsx(_components.p, {
        children: "Nettside: https://www.undervisningsplan.no/"
      })]
    });
  }
}
export default MDXContent;
